import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Button } from "react-bootstrap";
import LoaderInternal from "../../LoaderInternal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";

import { fetchTransferDetails } from "../../data/transfers/transferDetailsSlice";
import { fetchTransferPrice } from "../../data/transfers/transferPriceSlice";
import { useTranslation } from "react-i18next";
import { ru, ar, pt, es } from "date-fns/locale";
const TransferDetails = () => {
  const { t, i18n } = useTranslation();
  const getLocale = () => {
    switch (i18n.language) {
      case "ru":
        return ru;
      case "pt":
        return pt;
      case "es":
        return es;
      case "ar":
        return ar;
      default:
        return undefined; // Default to English if no match
    }
  };
  const { productUrl } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const language = useSelector((state) => state.language.language);
  const currency = useSelector((state) => state.currency.currency);
  const { transferDetails, loading, error } = useSelector(
    (state) => state.transferDetails
  );
  useEffect(() => {
    dispatch(fetchTransferDetails({ productUrl, currency, language }));
  }, [dispatch, productUrl, currency, language]);
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  const start1 = transferDetails.transferDetails?.bookingStartDate
    ? new Date(transferDetails.transferDetails.bookingStartDate)
    : null;
  const end1 = transferDetails.transferDetails?.bookingEndDate
    ? new Date(transferDetails.transferDetails.bookingEndDate)
    : null;

  const availableDaysIndex =
    transferDetails.transferDetails?.productEnableDays?.map((day) => {
      switch (day) {
        case "Sun":
          return 0;
        case "Mon":
          return 1;
        case "Tue":
          return 2;
        case "Wed":
          return 3;
        case "Thr":
          return 4;
        case "Fri":
          return 5;
        case "Sat":
          return 6;
        default:
          return -1;
      }
    });
  const isDateAvailable = (date) => {
    const dayIndex = date.getDay();
    return (
      date >= start1 && date <= end1 && availableDaysIndex.includes(dayIndex)
    );
  };
  const findFirstAvailableDate = () => {
    if (!start1 || !end1) return null;
    let date = addDays(new Date(), transferDetails.transferDetails?.cutOfDays); // Start from today
    date.setHours(0, 0, 0, 0); // Ensure time is set to 00:00:00
    date.setDate(date.getDate()); // Start from tomorrow
    while (date <= end1) {
      if (isDateAvailable(date)) {
        return date;
      }
      date.setDate(date.getDate() + 1);
    }
    return null;
  };
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [startDate, setStartDate] = useState(findFirstAvailableDate());

  useEffect(() => {
    const firstAvailableDate = findFirstAvailableDate();
    setStartDate(firstAvailableDate);
  }, [transferDetails]);
  const productId = transferDetails.transferDetails?.productId;

  const Transfers_participantNumber = localStorage.getItem(
    "Transfers_participantNumber"
  );
  const [adultNumber, setAdultNumber] = useState(
    Transfers_participantNumber || 1
  );
  const { transferPrice } = useSelector((state) => state.transferPrice);
  useEffect(() => {
    if (productId) {
      dispatch(
        fetchTransferPrice({
          productId,
          adultNumber,
          currency,
        })
      );
    }
  }, [dispatch, productId, currency, adultNumber]);
  const { bookingTour, loadingBooking, errorBooking } = useSelector(
    (state) => state.bookingTour
  );
  const handleSubmit = (e) => {
    e.preventDefault();
    // dispatch(
    //   fetchbookingTour({
    //     productId,
    //     numberOfchildrens1,
    //     currency,
    //     numberOfchildrens2,
    //     roomType,
    //     roomNumber,
    //     startDate: formatDate(startDate),
    //   })
    // );
    localStorage.setItem("transfer_productId", productId);
    localStorage.setItem("transfer_adultNumber", adultNumber);
    localStorage.setItem("transfer_startDate", formatDate(startDate));

    navigate(`bookingTransfer`);
  };
  const [activeTab, setActiveTab] = useState("rlr-product-sec-overview");
  const [showPopover, setShowPopover] = useState(false);

  const togglePopover = () => {
    setShowPopover(!showPopover);
  };
  // slider
  const [mainSplide, setMainSplide] = useState(null);
  const [thumbnailSplide, setThumbnailSplide] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [totalSlides, setTotalSlides] = useState(
    transferDetails.transferPhotos?.length
  );

  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });

      // Update currentIndex and totalSlides on main carousel change
      mainSplide.on("moved", () => {
        const index = mainSplide.index;
        setCurrentIndex(index + 1); // Splide uses zero-based index
        setTotalSlides(mainSplide.length);
      });
    }
  }, [mainSplide, thumbnailSplide]);
  // Effect to initialize Splide instances and synchronize them
  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });
    }
  }, [mainSplide, thumbnailSplide]);

  // Main carousel options
  const mainOptions = {
    type: "loop",
    perPage: 1,
    pagination: false,
    height: isMobile ? "50" : "75vh",
    drag: true,
    gap: 10,
    updateOnMove: true,
  };

  // Thumbnail carousel options
  const thumbnailOptions = {
    fixedWidth: 180,
    fixedHeight: 122,
    isNavigation: false,
    focus: "center",
    pagination: false,
    direction: "ttb",
    height: "75vh",
    gap: 10,
  };

  return (
    <>
      <Helmet>
        <title>
          {transferDetails.pageDetails?.pageMetatagTitle || "transfer"}
        </title>
        <link
          rel="canonical"
          href={`https://travco.com/${language}/transfers/${productUrl}`}
        />

        <meta
          name="description"
          content={transferDetails.pageDetails?.pageMetatagDescription}
        />
        <meta
          property="og:title"
          content={transferDetails.pageDetails?.metatagTitleFacebook}
        />
        <meta
          property="og:description"
          content={transferDetails.pageDetails?.metatagDescriptionFacebook}
        />
        <meta
          name="twitter:title"
          content={transferDetails.pageDetails?.metatagTitleTwitter}
        />
        <meta
          name="twitter:description"
          content={transferDetails.pageDetails?.metatagDescriptionTwitter}
        />
        <style type="text/css">
          {`
          .react-datepicker-wrapper{
          width:100%
          }
          .react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text, .react-datepicker__year-text{
          background-color:#ddd;
          border-radius:5px;
          }
          .react-datepicker__day--disabled, .react-datepicker__month-text--disabled, .react-datepicker__quarter-text--disabled, .react-datepicker__year-text--disabled{
          background-color:#fff;}

          `}
        </style>
      </Helmet>
      <section className="outter">
        <div
          id="rlr_banner_slider"
          className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
        >
          <div className="splide__track rlr-banner-splide__track">
            <ul className="splide__list height-internal-pages">
              <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                  <div className="overlay-banner"></div>
                  <Suspense fallback={<div>{t("Loading")}...</div>}>
                    <img
                      src={
                        isMobile
                          ? transferDetails.pageDetails?.pageBannerMobile
                          : isTablet
                          ? transferDetails.pageDetails?.pageBannerTablet
                          : transferDetails.pageDetails?.pageBannerPc
                      }
                      alt={transferDetails.pageDetails?.pageTitle}
                      loading="lazy"
                    />
                  </Suspense>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="rlr-search-results-page__breadcrumb-section">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb rlr-breadcrumb__items">
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/">{t("Home")} </Link>
              </li>
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/transfers-and-airport-services">
                  {t("Transfers and Airport Services")}
                </Link>
              </li>

              <li
                className="breadcrumb-item rlr-breadcrumb__item active"
                aria-current="page"
              >
                {transferDetails.pageDetails?.pageTitle}
              </li>
            </ol>
          </nav>
          <div className="rlr-icon-text">
            <i className="rlr-icon-font flaticon-phone-receiver-silhouette">
              {" "}
            </i>{" "}
            <Link
              to="tel:(+202) 3854 1010"
              className="rlr-search-results-page__phone"
            >
              {t("Questions")}{" "}
              {language == "ar" ? (
                <>
                  ؟ <span style={{ direction: "ltr" }}> (+202) 3854 1010</span>
                </>
              ) : (
                "? (+202) 3854 1010"
              )}{" "}
            </Link>
          </div>
        </div>
      </div>
      {/* Slides  */}
      {loading ? (
        <LoaderInternal />
      ) : (
        <section className="py-5 mt-lg-5">
          <div className="container">
            <aside className="row">
              <div className="rlr-product-detail-header__contents d-flex justify-content-between px-3">
                <h1 className="rlr-section__heading--main rlr-product-detail-header__title rlr-section__title--main">
                  {transferDetails.pageDetails?.pageTitle}{" "}
                </h1>{" "}
                <div
                  className="rlr-product-detail-header d-inline-block "
                  id="rlr-js-detail-header"
                >
                  <div className="rlr-product-detail-header__actions">
                    <button
                      type="button"
                      onClick={togglePopover}
                      id="rlr-js-share-button"
                      className="btn rlr-button rlr-button--circle rlr-popover-button  "
                      aria-label="share"
                    >
                      <i className="rlr-icon-font flaticon-share-1"></i>
                    </button>
                    <div
                      id="rlr-js-share-popover"
                      className={`rlr-popover ${
                        showPopover
                          ? "rlr-popover--visible"
                          : "rlr-popover--hide"
                      }`}
                    >
                      <div className="rlr-share">
                        <div className="d-flex justify-content-between align-items-center">
                          {" "}
                          <h3 className="rlr-share__title mb-5">
                            {t("Share with a friend")}{" "}
                          </h3>
                          <Button
                            type="button"
                            onClick={togglePopover}
                            className="btn btn-danger d-block mb-5"
                            style={{ borderRadius: "50%" }}
                          >
                            <FontAwesomeIcon icon={faClose} />
                          </Button>
                        </div>
                        <ul className="rlr-share__items">
                          <li className="rlr-share__list rlr-js--facebook">
                            <a
                              target="_blank"
                              href={`https://ww.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item"
                            >
                              <i className="rlr-icon-font flaticon-facebook"></i>
                              <span className="rlr-share__title">
                                {t("Facebook")}{" "}
                              </span>
                            </a>
                          </li>
                          <li className="rlr-share__list rlr-js--twitter">
                            <a
                              target="_blank"
                              href={`https://twitter.com/intent/tweet?text=${transferDetails.transferDetails?.pageTitle}&url=${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item social-links"
                            >
                              <span className="link twitter m-auto">
                                <span
                                  style={{
                                    margin: "auto",
                                    textAlign: "center",
                                    width: "35px",
                                    border: "2px solid #5c6770",
                                    height: "35px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center ",
                                  }}
                                ></span>
                              </span>
                              <span className="rlr-share__title">
                                {t("Twitter")}{" "}
                              </span>
                            </a>
                          </li>
                          <li className="rlr-share__list rlr-js--whatsapp">
                            <a
                              target="_blank"
                              href={`https://api.whatsapp.com/send?text=${transferDetails.pageDetails?.pageTitle}%20${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item"
                            >
                              <i className="rlr-icon-font flaticon-whatsapp"></i>
                              <span className="rlr-share__title">
                                {t("Whatsapp")}{" "}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {transferDetails.transferPhotos?.length > 0 && (
                <div className="row mx-auto   justify-content-lg-between px-0">
                  <div
                    className="col-12 col-md-10 m-auto position-relative px-0"
                    style={{ boxShadow: "0 0 5px 2px #eee" }}
                  >
                    <Splide options={mainOptions} onMounted={setMainSplide}>
                      {transferDetails.transferPhotos?.map((image, index) => (
                        <SplideSlide
                          key={index}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <img
                            src={`data:image/jpeg;base64,${image.photoFileBinary}`}
                            alt={`Slide ${index}`}
                            loading="lazy"
                            placeholder="Loading Images..."
                            style={{
                              width: "auto",
                              height: "auto",
                              borderRadius: ".5rem",
                            }}
                          />
                          <div className="rlr-media__custom-pagination rlr-js-custom-pagination">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.2 0C.542 0 0 .558 0 1.235v11.53C0 13.442.542 14 1.2 14h15.6c.658 0 1.2-.558 1.2-1.235V1.235C18 .558 17.458 0 16.8 0H1.2zm0 .824h15.6c.228 0 .4.176.4.411v9.844l-3.506-3.95a.4.4 0 0 0-.588 0l-2.862 3.126L6.1 5.488a.4.4 0 0 0-.362-.135.4.4 0 0 0-.232.129L.8 10.687V1.235C.8 1 .972.823 1.2.823zm9.2 2.058c-.879 0-1.6.743-1.6 1.647 0 .905.721 1.647 1.6 1.647.879 0 1.6-.742 1.6-1.647 0-.904-.721-1.647-1.6-1.647zm0 .824c.447 0 .8.363.8.823 0 .46-.353.824-.8.824a.806.806 0 0 1-.8-.824c0-.46.353-.823.8-.823zm-4.606 2.67 5.912 6.8H1.2a.397.397 0 0 1-.4-.411v-.869l4.994-5.52zm7.6 1.64 3.806 4.285v.464a.397.397 0 0 1-.4.411h-4.019l-2-2.303 2.613-2.856z"
                                fill="#212529"
                              ></path>
                            </svg>
                            <span className="rlr-media__page-counter rlr-js-page">
                              {index + 1} /{" "}
                              {transferDetails.transferPhotos?.length}
                            </span>
                          </div>
                        </SplideSlide>
                      ))}
                    </Splide>{" "}
                  </div>
                  {!isMobile && (
                    <div className="col-md-2">
                      <Splide
                        options={thumbnailOptions}
                        onMounted={setThumbnailSplide}
                      >
                        {transferDetails.transferPhotos?.map((image, index) => (
                          <SplideSlide key={index}>
                            <img
                              src={`data:image/jpeg;base64,${image.photoFileBinary}`}
                              alt={`Thumbnail ${index}`}
                              style={{
                                width: "100%",
                                height: "122px",
                                cursor: "pointer",
                                borderRadius: ".5rem",
                              }}
                              loading="lazy"
                              placeholder="Loading Images...."
                            />
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                  )}
                </div>
              )}
            </aside>
          </div>
        </section>
      )}
      <section className="container d-flex  justify-content-between align-items-start flex-wrap rlr-product-detail-section pb-5">
        <div className="rlr-product-detail-section__details col-lg-8">
          {/* Overview */}

          <div
            className="rlr-secondary-menu-desc mt-0"
            data-id="rlr-product-sec-overview"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <svg
                  width="41"
                  height="51"
                  viewBox="0 0 41 51"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M40.327 13.61H28.296c-.334 0-.558-.221-.558-.55l.002-11.852c0-.329.224-.55.558-.55.334 0 .558.221.558.55l-.002 11.304h11.473c.334 0 .558.22.558.55 0 .33-.224.547-.558.547z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M36.54 50.707H4.568C2.005 50.707 0 48.73 0 46.207L.002 5.047c0-2.525 2.005-4.5 4.568-4.5h23.728c.11 0 .334.109.445.109L40.885 12.51c.11.11.11.22.11.439v33.255c.113 2.527-1.892 4.503-4.455 4.503zM4.568 1.756c-1.892 0-3.342 1.428-3.342 3.292v41.158c0 1.867 1.56 3.402 3.453 3.402H36.65c1.894 0 3.453-1.537 3.453-3.402l.002-32.926-11.92-11.524H4.567z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M33.309 19.756h-19.27c-.335 0-.558-.22-.558-.55 0-.329.223-.549.557-.549h19.273c.334 0 .558.22.558.55-.002.329-.226.55-.56.55zM33.309 25.133H7.91c-.334 0-.558-.22-.558-.55 0-.328.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .331-.224.55-.558.55zM33.309 30.622H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.55.558-.55h25.399c.334 0 .558.221.558.55 0 .33-.224.55-.558.55zM33.309 36.11H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .329-.224.55-.558.55zM33.309 41.487H7.91c-.334 0-.558-.22-.558-.549 0-.33.224-.55.558-.55h25.399c.334 0 .558.22.558.55 0 .33-.224.55-.558.55z"
                    fill="#99A3AD"
                  ></path>
                </svg>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <div className="rlr-overview-detail">
                <div className="rlr-readmore-desc rlr-overview-detail__description">
                  <h4 className="rlr-section__title--main">
                    {" "}
                    {isMobile && (
                      <div className="rlr-secondary-menu-desc__icon d-inline-block">
                        <svg
                          width="35"
                          height="35"
                          viewBox="0 0 41 51"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M40.327 13.61H28.296c-.334 0-.558-.221-.558-.55l.002-11.852c0-.329.224-.55.558-.55.334 0 .558.221.558.55l-.002 11.304h11.473c.334 0 .558.22.558.55 0 .33-.224.547-.558.547z"
                            fill="#99A3AD"
                          ></path>
                          <path
                            d="M36.54 50.707H4.568C2.005 50.707 0 48.73 0 46.207L.002 5.047c0-2.525 2.005-4.5 4.568-4.5h23.728c.11 0 .334.109.445.109L40.885 12.51c.11.11.11.22.11.439v33.255c.113 2.527-1.892 4.503-4.455 4.503zM4.568 1.756c-1.892 0-3.342 1.428-3.342 3.292v41.158c0 1.867 1.56 3.402 3.453 3.402H36.65c1.894 0 3.453-1.537 3.453-3.402l.002-32.926-11.92-11.524H4.567z"
                            fill="#99A3AD"
                          ></path>
                          <path
                            d="M33.309 19.756h-19.27c-.335 0-.558-.22-.558-.55 0-.329.223-.549.557-.549h19.273c.334 0 .558.22.558.55-.002.329-.226.55-.56.55zM33.309 25.133H7.91c-.334 0-.558-.22-.558-.55 0-.328.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .331-.224.55-.558.55zM33.309 30.622H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.55.558-.55h25.399c.334 0 .558.221.558.55 0 .33-.224.55-.558.55zM33.309 36.11H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .329-.224.55-.558.55zM33.309 41.487H7.91c-.334 0-.558-.22-.558-.549 0-.33.224-.55.558-.55h25.399c.334 0 .558.22.558.55 0 .33-.224.55-.558.55z"
                            fill="#99A3AD"
                          ></path>
                        </svg>
                      </div>
                    )}{" "}
                    {t("Highlights")}
                  </h4>
                </div>
                <div className="rlr-overview-detail__icon-groupset">
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {" "}
                      {t("Location")}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-map-marker"></i>{" "}
                        <span>
                          {" "}
                          {transferDetails.transferDetails?.destinationName}
                        </span>
                      </figure>
                    </div>
                  </div>
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {t("Duration")}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-three-o-clock-clock"></i>{" "}
                        <span>
                          {" "}
                          {transferDetails.transferDetails?.fullDuration}
                        </span>
                      </figure>
                    </div>
                  </div>
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {" "}
                      {t("Run")}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-calendar"></i>{" "}
                        <span>
                          {transferDetails.transferDetails?.productRunDays}
                        </span>
                      </figure>
                    </div>
                  </div>
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {t("Group Size")}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-add-user"></i>{" "}
                        <span>
                          {
                            transferDetails.transferDetails
                              ?.productGroupSizeNameSys
                          }
                        </span>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span id="rlr-product-sec-itinerary-section"></span>
          {/* Itinerary   */}
          <div
            className="rlr-secondary-menu-desc"
            data-id="rlr-product-sec-itinerary"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <svg
                  width="43"
                  height="38"
                  viewBox="0 0 43 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43 .442c0-.016-.008-.03-.01-.047-.002-.015.003-.031 0-.047-.003-.014-.013-.024-.018-.037a.372.372 0 0 0-.035-.082.41.41 0 0 0-.177-.172.409.409 0 0 0-.08-.031.397.397 0 0 0-.085-.017C42.581.007 42.568 0 42.553 0c-.018 0-.032.008-.049.01-.016.002-.031-.003-.047 0L28.519 3.04 14.577.01h-.007c-.015-.003-.033 0-.05-.002-.013 0-.024-.008-.039-.008-.013 0-.025.006-.037.008-.018 0-.037 0-.054.003h-.004L.35 3.06c-.013.003-.024.013-.037.017a.44.44 0 0 0-.152.082.389.389 0 0 0-.059.062.438.438 0 0 0-.046.068.459.459 0 0 0-.049.165c0 .014-.008.025-.008.04v34.063c0 .017.008.03.01.047s-.001.03.002.047c.004.016.013.028.018.043a.377.377 0 0 0 .08.141c.014.017.026.033.042.047.026.023.056.04.087.058.017.009.031.02.049.026a.448.448 0 0 0 .255.022l13.94-3.03 13.94 3.03c.032.008.064.011.095.011.005 0 .01-.003.014-.003a.432.432 0 0 0 .082-.008l14.036-3.05c.014-.002.024-.012.037-.017a.47.47 0 0 0 .152-.082.44.44 0 0 0 .056-.06.43.43 0 0 0 .049-.07.432.432 0 0 0 .03-.075.374.374 0 0 0 .018-.089c0-.014.008-.025.008-.04V.443zM.894 3.85 14.037.993v16.584a.446.446 0 0 0-.272.136.44.44 0 0 0 .032.625c.082.073.158.151.24.225v15.589L.894 37.008V3.85zM14.93 19.413c.275.273.544.544.785.792a.448.448 0 0 0 .63.011.44.44 0 0 0 .012-.625 48.965 48.965 0 0 0-1.427-1.407V.993l13.144 2.856v21.217c-.259.11-.517.208-.776.284a.44.44 0 0 0 .125.866.446.446 0 0 0 .126-.019c.174-.051.35-.113.525-.178v10.988l-13.144-2.856V19.413zm14.036 6.215a9.751 9.751 0 0 0 1.137-.678.44.44 0 0 0 .11-.616.448.448 0 0 0-.62-.11 9.369 9.369 0 0 1-.627.398V3.85L42.108.993v33.159l-13.143 2.855V25.628z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M5.452 26.484a26.968 26.968 0 0 1-.167-.966.445.445 0 0 0-.508-.37.442.442 0 0 0-.373.504c.055.352.105.634.147.857a2.365 2.365 0 0 0-1.848 2.297 2.37 2.37 0 0 0 2.378 2.358 2.37 2.37 0 0 0 2.378-2.358c-.001-1.174-.873-2.143-2.007-2.322zM5.08 30.28c-.82 0-1.487-.661-1.487-1.474S4.26 27.33 5.08 27.33c.82 0 1.486.662 1.486 1.475 0 .813-.667 1.474-1.486 1.474zM38.218 6.8l1.051-1.043a.44.44 0 0 0 0-.625.449.449 0 0 0-.63 0l-1.051 1.043-1.05-1.043a.449.449 0 0 0-.631 0 .44.44 0 0 0 0 .625L36.958 6.8l-1.051 1.043a.44.44 0 0 0 .316.755.45.45 0 0 0 .315-.13l.66-.656c.005.106.01.204.013.323.006.24.204.432.445.432h.012a.444.444 0 0 0 .434-.453l-.006-.185.542.539a.45.45 0 0 0 .631 0 .44.44 0 0 0 0-.626L38.22 6.8zM12.178 15.992c-.9-.55-1.764-.9-2.644-1.073a.441.441 0 1 0-.173.867c.773.152 1.542.466 2.35.959a.448.448 0 0 0 .613-.146.44.44 0 0 0-.146-.607zM4.551 23.348l.028-.001a.445.445 0 0 0 .418-.468 21.743 21.743 0 0 1-.042-1.335c0-.433.014-.869.048-1.3a.443.443 0 0 0-.41-.475c-.244-.032-.46.164-.479.406-.036.453-.05.913-.05 1.369 0 .47.015.938.043 1.388.014.235.21.416.444.416zM4.94 17.99a.447.447 0 0 0 .577-.254c.34-.877.834-1.479 1.47-1.788a.44.44 0 0 0 .202-.592.448.448 0 0 0-.596-.202c-.844.411-1.486 1.174-1.908 2.265a.439.439 0 0 0 .255.57zM18.24 21.53a.45.45 0 0 0-.63-.004.44.44 0 0 0-.003.626 27.948 27.948 0 0 0 2.017 1.868.444.444 0 0 0 .628-.057.44.44 0 0 0-.057-.623 27.215 27.215 0 0 1-1.954-1.81zM37.629 10.418a.443.443 0 0 0-.478.41c-.07.942-.19 1.822-.357 2.612a.442.442 0 0 0 .438.533c.206 0 .39-.143.435-.351.175-.828.301-1.746.374-2.729a.446.446 0 0 0-.412-.475zM36.584 15.69a.447.447 0 0 0-.594.209c-.051.105-.104.209-.16.311-.306.561-.686 1.257-1.138 2.015a.44.44 0 0 0 .157.606.45.45 0 0 0 .611-.155c.459-.77.845-1.476 1.155-2.045.062-.115.123-.232.18-.35a.44.44 0 0 0-.211-.59zM33.236 20.46a20.156 20.156 0 0 1-1.677 2.046.441.441 0 0 0 .326.745.446.446 0 0 0 .325-.14c.585-.62 1.174-1.339 1.75-2.137a.44.44 0 0 0-.102-.616.446.446 0 0 0-.622.101zM24.791 25.553a7.526 7.526 0 0 1-2.417-.754.446.446 0 0 0-.631.222.44.44 0 0 0 .21.558l.017.01c.904.448 1.816.731 2.712.842a.445.445 0 0 0 .498-.384.443.443 0 0 0-.389-.494z"
                    fill="#99A3AD"
                  ></path>
                </svg>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <div className="rlr-readmore-desc">
                <h4 className="rlr-section__title--main">
                  {" "}
                  {isMobile && (
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 43 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="m-3"
                    >
                      <path
                        d="M43 .442c0-.016-.008-.03-.01-.047-.002-.015.003-.031 0-.047-.003-.014-.013-.024-.018-.037a.372.372 0 0 0-.035-.082.41.41 0 0 0-.177-.172.409.409 0 0 0-.08-.031.397.397 0 0 0-.085-.017C42.581.007 42.568 0 42.553 0c-.018 0-.032.008-.049.01-.016.002-.031-.003-.047 0L28.519 3.04 14.577.01h-.007c-.015-.003-.033 0-.05-.002-.013 0-.024-.008-.039-.008-.013 0-.025.006-.037.008-.018 0-.037 0-.054.003h-.004L.35 3.06c-.013.003-.024.013-.037.017a.44.44 0 0 0-.152.082.389.389 0 0 0-.059.062.438.438 0 0 0-.046.068.459.459 0 0 0-.049.165c0 .014-.008.025-.008.04v34.063c0 .017.008.03.01.047s-.001.03.002.047c.004.016.013.028.018.043a.377.377 0 0 0 .08.141c.014.017.026.033.042.047.026.023.056.04.087.058.017.009.031.02.049.026a.448.448 0 0 0 .255.022l13.94-3.03 13.94 3.03c.032.008.064.011.095.011.005 0 .01-.003.014-.003a.432.432 0 0 0 .082-.008l14.036-3.05c.014-.002.024-.012.037-.017a.47.47 0 0 0 .152-.082.44.44 0 0 0 .056-.06.43.43 0 0 0 .049-.07.432.432 0 0 0 .03-.075.374.374 0 0 0 .018-.089c0-.014.008-.025.008-.04V.443zM.894 3.85 14.037.993v16.584a.446.446 0 0 0-.272.136.44.44 0 0 0 .032.625c.082.073.158.151.24.225v15.589L.894 37.008V3.85zM14.93 19.413c.275.273.544.544.785.792a.448.448 0 0 0 .63.011.44.44 0 0 0 .012-.625 48.965 48.965 0 0 0-1.427-1.407V.993l13.144 2.856v21.217c-.259.11-.517.208-.776.284a.44.44 0 0 0 .125.866.446.446 0 0 0 .126-.019c.174-.051.35-.113.525-.178v10.988l-13.144-2.856V19.413zm14.036 6.215a9.751 9.751 0 0 0 1.137-.678.44.44 0 0 0 .11-.616.448.448 0 0 0-.62-.11 9.369 9.369 0 0 1-.627.398V3.85L42.108.993v33.159l-13.143 2.855V25.628z"
                        fill="#99A3AD"
                      ></path>
                      <path
                        d="M5.452 26.484a26.968 26.968 0 0 1-.167-.966.445.445 0 0 0-.508-.37.442.442 0 0 0-.373.504c.055.352.105.634.147.857a2.365 2.365 0 0 0-1.848 2.297 2.37 2.37 0 0 0 2.378 2.358 2.37 2.37 0 0 0 2.378-2.358c-.001-1.174-.873-2.143-2.007-2.322zM5.08 30.28c-.82 0-1.487-.661-1.487-1.474S4.26 27.33 5.08 27.33c.82 0 1.486.662 1.486 1.475 0 .813-.667 1.474-1.486 1.474zM38.218 6.8l1.051-1.043a.44.44 0 0 0 0-.625.449.449 0 0 0-.63 0l-1.051 1.043-1.05-1.043a.449.449 0 0 0-.631 0 .44.44 0 0 0 0 .625L36.958 6.8l-1.051 1.043a.44.44 0 0 0 .316.755.45.45 0 0 0 .315-.13l.66-.656c.005.106.01.204.013.323.006.24.204.432.445.432h.012a.444.444 0 0 0 .434-.453l-.006-.185.542.539a.45.45 0 0 0 .631 0 .44.44 0 0 0 0-.626L38.22 6.8zM12.178 15.992c-.9-.55-1.764-.9-2.644-1.073a.441.441 0 1 0-.173.867c.773.152 1.542.466 2.35.959a.448.448 0 0 0 .613-.146.44.44 0 0 0-.146-.607zM4.551 23.348l.028-.001a.445.445 0 0 0 .418-.468 21.743 21.743 0 0 1-.042-1.335c0-.433.014-.869.048-1.3a.443.443 0 0 0-.41-.475c-.244-.032-.46.164-.479.406-.036.453-.05.913-.05 1.369 0 .47.015.938.043 1.388.014.235.21.416.444.416zM4.94 17.99a.447.447 0 0 0 .577-.254c.34-.877.834-1.479 1.47-1.788a.44.44 0 0 0 .202-.592.448.448 0 0 0-.596-.202c-.844.411-1.486 1.174-1.908 2.265a.439.439 0 0 0 .255.57zM18.24 21.53a.45.45 0 0 0-.63-.004.44.44 0 0 0-.003.626 27.948 27.948 0 0 0 2.017 1.868.444.444 0 0 0 .628-.057.44.44 0 0 0-.057-.623 27.215 27.215 0 0 1-1.954-1.81zM37.629 10.418a.443.443 0 0 0-.478.41c-.07.942-.19 1.822-.357 2.612a.442.442 0 0 0 .438.533c.206 0 .39-.143.435-.351.175-.828.301-1.746.374-2.729a.446.446 0 0 0-.412-.475zM36.584 15.69a.447.447 0 0 0-.594.209c-.051.105-.104.209-.16.311-.306.561-.686 1.257-1.138 2.015a.44.44 0 0 0 .157.606.45.45 0 0 0 .611-.155c.459-.77.845-1.476 1.155-2.045.062-.115.123-.232.18-.35a.44.44 0 0 0-.211-.59zM33.236 20.46a20.156 20.156 0 0 1-1.677 2.046.441.441 0 0 0 .326.745.446.446 0 0 0 .325-.14c.585-.62 1.174-1.339 1.75-2.137a.44.44 0 0 0-.102-.616.446.446 0 0 0-.622.101zM24.791 25.553a7.526 7.526 0 0 1-2.417-.754.446.446 0 0 0-.631.222.44.44 0 0 0 .21.558l.017.01c.904.448 1.816.731 2.712.842a.445.445 0 0 0 .498-.384.443.443 0 0 0-.389-.494z"
                        fill="#99A3AD"
                      ></path>
                    </svg>
                  )}{" "}
                  {t("Itinerary")}
                </h4>
              </div>

              <div
                className="rlr-readmore-desc__content rlr-js-desc"
                dangerouslySetInnerHTML={{
                  __html: transferDetails.transferDetails?.productDetails,
                }}
              />
            </div>
          </div>
        </div>

        {/* Booking Engine  */}
        <aside className="col-12 col-lg-4 col-xxxl-3 d-xl-block offset-xxxl-1 mt-5 mt-lg-0 px-lg-4">
          <form className="col-12" onSubmit={handleSubmit}>
            <fieldset className="rlr-fieldrow mt-0">
              <article
                itemScope
                itemType="https://schema.org/Offer"
                className="rlr-booking-card__price-details rlr-fieldrow__form-element"
              >
                <span className="rlr-booking-card__total-price">
                  {t("Total price")}
                </span>{" "}
                <header className="rlr-booking-card__offer">
                  <h2
                    className="rlr-booking-card__price"
                    itemScope
                    itemType="https://schema.org/AggregateOffer"
                  >
                    <span
                      className="rlr-booking-card__current-price rlr-booking-card--currency"
                      itemProp="priceCurrency"
                    />
                    <span
                      id="Price"
                      itemProp="lowPrice"
                      className="rlr-booking-card__current-price rlr-booking-card--low-price"
                    >
                      {transferDetails.transferDetails?.priceCurrency}
                      {transferPrice}
                    </span>
                    <span
                      itemProp="category"
                      className="rlr-booking-card__price-type rlr-booking-card__price-type--result"
                    >
                      {t("inc. taxes")}
                    </span>
                  </h2>
                  <svg width="56" height="57" viewBox="0 0 56 57" fill="none">
                    <rect
                      y=".411"
                      width="56"
                      height="56"
                      rx="28"
                      fill="#28B0A6"
                    ></rect>
                    <path
                      d="M24.253 40.365a1.629 1.629 0 0 1-2.31 0l-9.225-9.226a2.45 2.45 0 0 1 0-3.466l1.155-1.155a2.45 2.45 0 0 1 3.466 0l5.76 5.76L38.66 16.715a2.45 2.45 0 0 1 3.466 0l1.155 1.155a2.45 2.45 0 0 1 0 3.465l-19.029 19.03z"
                      fill="#fff"
                    ></path>
                  </svg>
                </header>
              </article>
              <div className="rlr-fieldrow__item rlr-booking-card__form-item">
                <label
                  className="rlr-form-label rlr-form-label--dark rlr-booking-card__label"
                  htmlFor="rlr-booking-dateranges-input"
                >
                  {t("Dates")}
                </label>
                <div
                  className="rlr-input-group rlr-input-group__datefield rlr-js-booking-form-daterange"
                  id="rlr-booking-startRange"
                >
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                    }}
                    className="form-control form-input"
                    placeholderText="Select preferred dates"
                    minDate={addDays(
                      new Date(),
                      transferDetails.transferDetails?.cutOfDays
                    )}
                    maxDate={end1}
                    filterDate={isDateAvailable}
                    required
                    locale={getLocale()}
                  />
                </div>
              </div>
              <div className="rlr-fieldrow__item rlr-booking-card__form-item">
                <div className="d-flex justify-content-between col-12 mb-3">
                  <div className="rlr-fieldrow_item rlr-booking-card_form-item col-5 d-flex flex-column">
                    <label className="rlr-form-label rlr-form-label--dark rlr-booking-card__label">
                      {t("Adults")}
                    </label>
                    <input
                      id="RoomNumber"
                      type="Number"
                      className="form-control"
                      value={adultNumber}
                      onChange={(e) => setAdultNumber(e.target.value)}
                      min="1"
                      required
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <button
              type="submit"
              className="btn rlr-button rlr-booking-card__button"
            >
              {t("Proceed to Booking")}
            </button>
          </form>
        </aside>
      </section>
    </>
  );
};

export default TransferDetails;
